<template>
    <div class="col-sm-12 col-md-6 col-lg-4">
        <card>
            <base-input
                :value="musiconhold.name"
                label="Name"
                required
                name="name"
                v-validate="'required|min:3|max:50'"
                @input="handleNameInputChange"
                :error="getError('name')"
            ></base-input>

            <div v-if="musiconhold.has_recording">
                <base-input label="Current Recording">
                    <vue-plyr :emit="['progress']"
                              v-show="canPlay"
                              @progress="setRecordingPlayable"
                              :options="{'controls': [ 'play','progress', 'current-time', 'mute','download']}">
                        <audio controls>
                            <source :src="musiconhold.recording" type="audio/wav"/>
                        </audio>
                    </vue-plyr>
                    <h1 v-show="!canPlay" class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']"
                                                                                       spin></font-awesome-icon></span>
                    </h1>

                </base-input>
            </div>

            <div v-if="!musiconhold.has_recording">
                <base-input label="No custom recording" class="mb-5">
                    <span></span>
                </base-input>
            </div>

            <hr>
            <h4>Upload a custom recording.</h4>
            <el-upload
                class="upload-demo"
                ref="upload"
                :multiple="false"
                accept="audio/*"
                :limit="1"
                :auto-upload="false"
                :on-change="playFile"
                :on-remove='removeFile'
                action="">
                <base-button type="info" slot="trigger" size="small">Select recording</base-button>
                <div class="el-upload__tip" slot="tip">Only audio files with a filesize less than 5MB.</div>
            </el-upload>
            <vue-plyr v-if="recording" :options="{'controls': [ 'play','progress', 'duration', 'mute', 'volume']}">
                <audio>
                    <source :src="recording" type="audio/wav"/>
                </audio>
            </vue-plyr>


            <div slot="footer">
                <div class="row">
                    <div class="col">
                        <base-button class="left" :loading="saving" :disabled="!dirty"
                                     @click="save" type="primary">
                            Save
                        </base-button>


                        <base-button icon @click="remove" type="danger" :loading="removing"
                                     class="right">
                            <font-awesome-icon v-if="!removing" :icon="['fal','trash']"></font-awesome-icon>
                        </base-button>

                    </div>
                </div>

            </div>
        </card>
    </div>
</template>
<script>
    import swal from 'sweetalert2';
    import BaseSwitch from "../../components/BaseSwitch";

    export default {
        name: 'MusicOnHoldCard',
        components: {
            BaseSwitch
        },
        props: {
            initialMusicOnHold: {}
        },
        computed: {},
        data() {
            return {
                dirty: false,
                removing: false,
                saving: false,
                musiconhold: null,
                origName: '',
                recording: null,
                file: null,
                canPlay: false,
            }
        },
        created() {
            this.musiconhold = JSON.parse(JSON.stringify(this.initialMusicOnHold));
            this.origName = this.musiconhold.name;
        },
        methods: {
            setRecordingPlayable() {
                this.canPlay = true;
            },
            removeFile(file, filelist) {
                this.recording = null;
                this.file = null;
            },
            playFile(file, filelist) {
                var binaryData = [];
                binaryData.push(file.raw);
                this.file = file;
                this.recording = window.URL.createObjectURL(new Blob(binaryData, {type: "audio/mp3"}));
                this.dirty = true;
            },
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            handleNameInputChange(value) {
                this.musiconhold.name = value.replace(/[#,."'/\\`~ :;}{|$&%^?+*]/g, '');
                this.dirty = true;
                this.$emit('dirty', this.dirty);
            },
            save() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.saving = true;
                        let name = this.musiconhold.name;
                        let id = this.musiconhold.id;
                        let file = null;
                        if (this.file) {
                            file = this.file.raw;
                        }

                        this.$store.dispatch('musiconhold/save', {id, name, file}).then(() => {
                            this.dirty = false;
                            this.saving = false;
                            this.$emit('saved');
                            this.reloadItemsAffectedByMusicOnHold();
                            this.$notify({
                                verticalAlign: 'bottom',
                                horizontalAlign: 'right',
                                message: 'Your MusicOnHold: ' + name + ' was saved!',
                                type: "success",
                                iconClass: "fal fa-save",
                                title: "Saved!"
                            });

                        }).catch((err) => {
                            this.saving = false;
                            this.$notify({
                                position: "bottom-right",
                                message: err.message,
                                type: "error",
                                duration: 5000,
                                iconClass: "fal fa-times",
                                title: "Error!"
                            },);
                        });
                    }
                })
            },
            remove() {
                swal.fire({
                    title: 'Are you sure?',
                    text: "This will delete the Music On Hold! You won't be able to restore this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.removing = true;
                        let id = this.musiconhold.id;
                        this.$store.dispatch('musiconhold/remove', {id}).then(() => {
                            this.$notify({
                                message: 'Your MusicOnHold: ' + this.musiconhold.name + ' was removed!',
                                type: "success",
                                iconClass: "fal fa-trash",
                                title: "Removed!"
                            });

                            this.dirty = false;
                            this.saving = false;
                            this.removing = false;
                            this.$emit('removed');
                        }).catch(() => {
                            this.$notify({
                                message: 'Failed to remove!',
                                type: "error",
                                iconClass: "fal fa-times",
                                title: "Error!"
                            });
                            this.removing = false;
                        })
                    }
                });
            },
            reloadItemsAffectedByMusicOnHold() {
                this.$store.dispatch('did/loadUniqueDIDs');
                this.$store.dispatch('sipdevice/loadSIPDevices');

            }
        },
    }
</script>
